export const emailRegex = new RegExp(
  '^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,4}$'
);

export function getShortenedSubstring(name, length, allowDots = true) {
  if (name) {
    return name.length < length
      ? name
      : `${name.substr(0, length)}${allowDots && '...'}`;
  }

  return '';
}

export function getAppDownloadLink(androidLink = '', iosLink = '') {
  if (typeof window !== 'undefined') {
    const userAgent = window.navigator?.userAgent;

    if (/Android/.test(userAgent) && androidLink) {
      return androidLink;
    }

    if (/iPad|iPhone|iPod/.test(userAgent) && iosLink) {
      return iosLink;
    }

    return androidLink || iosLink;
  }
}
